import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handlePostCommentFailed(
  state: State,
  { discussion, comment }: Boundaries["postComment"]["failure"],
): State {
  return state.map((result) =>
    result.discussion.uuid === discussion.uuid
      ? {
          ...result,
          discussion: {
            ...result.discussion,
            comments: result.discussion.comments.filter(
              ({ uuid }) => uuid !== `__pending__${comment.content}`,
            ),
          },
        }
      : result,
  );
}

export { handlePostCommentFailed };
